// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1PHRB","icon":"SortAdornment_icon__2ekh8","up":"SortAdornment_up__1TDS3","down":"SortAdornment_down__1LtX6","active":"SortAdornment_active__1jaOZ"};